import styled from 'styled-components';
export const Container = styled.div`
   position: relative;
   display: flex;
   width: 310px;
   flex-direction: column;
   padding: 0.3rem;
   border-radius: 10px;
   box-shadow: 0 1px 1px #ccc;
   background-color: ${({ isUserSystem }) => isUserSystem ? ' #E7F8FF' : '#ffffff'};
   user-select: none;
   gap: .3rem;
   > span {
      font-weight: 700;
      color:#7b7b7b;
   }
   &:hover{
      > span {
         opacity: 0.8;
      }
   }
   cursor: pointer;
`;
export const Content = styled.div`
   display: flex;
   width: 100%;
   padding: .3rem;
   flex-direction: column;
   align-items: center;
   border-radius: 10px;
   background-color:#f6f6f6f6; 
   > div {
      width: 100%;
      display: flex;
      gap: .5rem;
      align-items: center;
   }
`;
export const IconContact = styled.div`
   display: flex;
   height: 3.5rem;
   width: 3.5rem;
   justify-content: center;
   align-items: center;
   border-radius: 50%;
   color:#1D86FF;
`;
export const Description = styled.div`
   display: flex;
   max-width: calc(100% - 5rem);
   > div {
      text-align: left;
      font-weight: 600;
      font-size: .975rem;
      line-height: 1.4286;
      overflow: auto;
   }
`;